import React from "react";
import { BrowserRouter, Switch, Redirect, Route, Link, NavLink } from "react-router-dom";


var ReactDOM = require('react-dom')


export class Wallet2 extends React.Component {


    constructor(props) {
        super(props);


        this.state = {
            currentStep: 1,
            errorMsg: null,
            successMsg: null,
            naCasino: true,
            iznos: "0,00",
            pokerReloadBonus: false,
            casinoReloadBonus: false,
            close: false,
            moneyTransferInProgress: false
        };




        this.showModal = this.showModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.validate = this.validate.bind(this);

        this.odabirIznosa = this.odabirIznosa.bind(this);
        this.iznosChanged = this.iznosChanged.bind(this);


        this.kreirajPrijenos = this.kreirajPrijenos.bind(this);
        this.submitForm = this.submitForm.bind(this);
        this.windowResize = this.windowResize.bind(this);



        this.overlyClick = this.overlyClick.bind(this);



        this.el = document.createElement('div');

        this.overlayTouchMove = this.overlayTouchMove.bind(this);
        this.modalTouchStart = this.modalTouchStart.bind(this);
        this.modalTouchMove = this.modalTouchMove.bind(this);
        this.modalTouchEnd = this.modalTouchEnd.bind(this);
        this.setIznos = this.setIznos.bind(this);

        this.clickChangeIznosPlus = this.clickChangeIznosPlus.bind(this);
        this.clickChangeIznosMinus = this.clickChangeIznosMinus.bind(this);

        this.bonusChboxClick = this.bonusChboxClick.bind(this);
        this.bonusPokerChboxClick = this.bonusPokerChboxClick.bind(this);

        this.txtIznos = React.createRef();
        this.modal = React.createRef();
        this.modalOverlay = React.createRef();
        this.modalInnerOverlay = React.createRef();
        this.modalContent = React.createRef();
    }


    overlayTouchMove(event) {
        event.preventDefault();
    }
    modalTouchStart(event) {

        var modalDiv = this.modalContent.current;



        var touch = event.targetTouches[0];
        this._start = touch.pageY;
        this._end = -1;
        modalDiv.className = modalDiv.className + " no-animation";
    }
    modalTouchMove(event) {

        var modalDiv = this.modalContent.current;


        var touch = event.targetTouches[0];
        this._end = touch.pageY;
        var diff = this._end - this._start;

        if (diff > 0) {
            modalDiv.style.transform = 'translate3d(0%,' + diff + 'px,0)';
        } else {
            modalDiv.style.transform = 'translate3d(0%,0px,0)';
        }

        event.preventDefault();

    }
    modalTouchEnd(event) {

        var modalDiv = this.modalContent.current;

        modalDiv.className = modalDiv.className.replace("no-animation", "").trim();
        modalDiv.style.transform = null;

        if (this._end > -1 && (this._end - this._start) > 100) {
            if (this.state.currentStep == 2 || this.state.currentStep == 4)
                this.setState({ close: true });
        }
    }



    componentDidMount() {
        window.addEventListener('resize', this.windowResize);
        document.getElementById('modal').appendChild(this.el);

        var modalDiv = this.modalContent.current;
        var overlayDiv = this.modalOverlay.current;
        var innerOverlyDiv = this.modalInnerOverlay.current;


        // zabranimo scrolanje backgounda
        overlayDiv.addEventListener('touchmove', this.overlayTouchMove, false);
        innerOverlyDiv.addEventListener('touchmove', this.overlayTouchMove, false);

        // postavimo evente na prozor od igre
        modalDiv.addEventListener('touchstart', this.modalTouchStart, false);
        modalDiv.addEventListener('touchmove', this.modalTouchMove, false);
        modalDiv.addEventListener('touchend', this.modalTouchEnd, false);

        var showNaCasino = this.props.route && this.props.route.location && this.props.route.location.state && this.props.route.location.state.showNaCasino;

        if (showNaCasino) {
            setTimeout(() => {
                this.setState({ currentStep: 2 });
                this.windowResize();
            }, 50);
        }
    }

    componentWillUnmount() {


        var modalDiv = this.modalContent.current;
        var overlayDiv = this.modalOverlay.current;
        var innerOverlyDiv = this.modalInnerOverlay.current;

        overlayDiv.removeEventListener('touchmove', this.overlayTouchMove);
        innerOverlyDiv.removeEventListener('touchmove', this.overlayTouchMove);
        modalDiv.removeEventListener('touchstart', this.modalTouchStart);
        modalDiv.removeEventListener('touchmove', this.modalTouchMove);
        modalDiv.removeEventListener('touchend', this.modalTouchEnd);

        window.removeEventListener('resize', this.windowResize);
        document.getElementById('modal').removeChild(this.el);
    }


    windowResize() {


        cancelAnimationFrame(this.resizeFrame);

        this.resizeFrame = requestAnimationFrame(
            () => {
                if (this.modal.current) {
                    // ako je dovoljno veliko onda sredina inače bottom
                    var height = window.innerHeight;
                    var div2Height = this.modalContent.current.clientHeight;
                    if (div2Height <= height) {
                        this.modalContent.current.style.top = (height - div2Height) / 2 + 'px';
                    } else {
                        this.modalContent.current.style.top = (height - div2Height - 5) + 'px';
                    }
                }
            });
    }






    showModal(naCasino) {

        //Google tag manager
        casino.utils.createGoogleTagManagerEvent({
            'event': naCasino ? 'moneytransfer_casino_click' : 'moneytransfer_main_click',
            'current_balance': this.props.user.sportRaspolozivo + this.props.user.casinoRaspolozivo,
            'current_balance_sport': this.props.user.sportRaspolozivo,
            'current_balance_casino': this.props.user.casinoRaspolozivo
        });



        var modalDiv = this.modalContent.current;
        modalDiv.style.transform = 'translate3d(0,0,0)';

        this.setState({ naCasino: naCasino, currentStep: 2, errorMsg: null, successMsg: null, pokerReloadBonus: false, iznos: "0,00", close: false });



        setTimeout(() => {
            this.windowResize();
        }, 1);

    }
    closeModal() {
        this.setState({ currentStep: 1, errorMsg: null, successMsg: null, pokerReloadBonus: false, close: true });
    }



    odabirIznosa(iznos) {
        var zeljeniIznos = null;
        if (iznos == -1) {
            if (this.state.naCasino === true)
                zeljeniIznos = this.props.user.sportRaspolozivo;
            if (this.state.naCasino === false)
                zeljeniIznos = iznos = this.props.user.casinoRaspolozivoZaIsplatu;
        } else {
            zeljeniIznos = iznos;
        }
        this.setState({ iznos: zeljeniIznos ? casino.utils.numberToString(zeljeniIznos) : "0,00", currentStep: 1, errorMsg: null, successMsg: null });
    }


    clickChangeIznosPlus() {

        var iznos = casino.utils.stringToNumber(this.state.iznos) || 0.0;
        var max = this.state.naCasino ? this.props.user.sportRaspolozivo : this.props.user.casinoRaspolozivoZaIsplatu;


        if (iznos >= 50) {
            iznos += 50;
        }
        if (iznos < 50) {
            iznos += 10;
        }
        if (iznos > max) {
            iznos = max;
        }


        this.setState({ iznos: casino.utils.numberToString(iznos), errorMsg: null, successMsg: null, moneyTransferInProgress: false });




    }

    clickChangeIznosMinus() {
        var iznos = casino.utils.stringToNumber(this.state.iznos) || 0.0;


        if (iznos <= 50) {
            iznos -= 10;
        }

        if (iznos > 50) {
            iznos -= 50;
        }
        if (iznos < 0) {
            iznos = 0;
        }


        this.setState({ iznos: casino.utils.numberToString(iznos), errorMsg: null, successMsg: null });

    }

    iznosChanged(event) {
        var iznos = casino.utils.clearToNumberChars(event.target.value);
        this.setState({ iznos: iznos, currentStep: 2, errorMsg: null, successMsg: null, moneyTransferInProgress: false });
    }

    getPresentClass(iznos) {
        var className = "btn-present as-inline-block width-18-percent";
        if (iznos == -1 && this.state.naCasino != null)
            iznos = this.state.naCasino ? this.props.user.casinoRaspolozivoZaIsplatu : this.props.user.sportRaspolozivo;

        if (casino.utils.stringToNumber(this.state.iznos) == iznos) {
            className += " selected";
        }

        return className;
    }


    validate() {
        var max = this.state.naCasino ? this.props.user.sportRaspolozivo : this.props.user.casinoRaspolozivoZaIsplatu

        var number = casino.utils.stringToNumber(this.state.iznos);
        if (!number || number <= 0) {
            this.setState(casino.config.guiValuta == "HRK" ? { errorMsg: "Upišite valjani iznos veći od 0,00 kn" } : { errorMsg: "Upišite valjani iznos veći od 0,00 €" })
            return false;
        }

        if (number > max) {
            this.setState({ errorMsg: "Nemate dovoljno sredstava." })
            return false;
        }

        if (this.props.activePokerReloadPromotion && this.state.pokerReloadBonus) {
            var max = 0;
            var min = 0;
            this.state && this.props.promotions && this.props.promotions.availableItems.map(x => {
                if (x.poker) {
                    max = x.maxBonusDeposit.toFixed(2);
                    min = x.minDeposit;
                }
            });
            if (number < min) {
                this.setState({ errorMsg: "Min. iznos za akt. bonusa je " + min + "€!" })
                return false;
            }
            if (number > max) {
                this.setState({ errorMsg: "Maks. iznos za akt. bonusa je " + max + "€!" })
                return false;
            }
        }

        let activeCasinoPromotion = this.props.user.promocije && this.props.user.promocije.availableItems.length > 0 && this.props.user.promocije.availableItems[0];
        if (activeCasinoPromotion && this.state.casinoReloadBonus) {
            if (number < activeCasinoPromotion.minDeposit) {
                this.setState({ errorMsg: "Min. iznos za akt. bonusa je " + activeCasinoPromotion.minDeposit + "€!" })
                return false;
            }

            if (!activeCasinoPromotion.jeFreeSpinDepositPonuda && number > activeCasinoPromotion.maxBonusDeposit) {
                this.setState({ errorMsg: "Maks. iznos za akt. bonusa je " + activeCasinoPromotion.maxBonusDeposit.toFixed(2) + "€!" })
                return false;
            }
        }

        this.setState({ iznos: casino.utils.numberToString(number), currentStep: 2, errorMsg: null, successMsg: null });
        return true;
    }


    setIznos(postotak) {
        var max = this.state.naCasino ? this.props.user.sportRaspolozivo :  this.props.user.casinoRaspolozivoZaIsplatu;
        this.setState({ iznos: casino.utils.numberToString(max*postotak), errorMsg: null, successMsg: null, moneyTransferInProgress: false });
    }

    kreirajPrijenos() {
        var that = this;
        this.setState({ currentStep: 3 });

        casino.repos.walletRepo.create(casino.utils.stringToNumber(this.state.iznos), this.state.naCasino, {
            pokerReloadBonus: this.state.pokerReloadBonus,
            casinoReloadBonusId: this.state.casinoReloadBonus ? this.state.casinoReloadBonusId : null
        }).then(function (data) {

            var newState = {
                errorMsg: null,
                successMsg: null,
                currentStep: 4,
                pokerReloadBonus: false,
                casinoReloadBonus: false,
                moneyTransferInProgress: false
            }

            if (data.ok) {
                casino.utils.createGoogleTagManagerEvent({
                    'event': data.naCasino ? 'moneytransfer_casino' : 'moneytransfer_main',
                    'amount': data.iznos,
                    'previous_balance': that.props.user.sportRaspolozivo + that.props.user.casinoRaspolozivo,
                    'previous_sport_balance': that.props.user.sportRaspolozivo,
                    'previous_casino_balance': that.props.user.casinoRaspolozivo,
                    'current_balance': that.props.user.sportRaspolozivo + that.props.user.casinoRaspolozivo,
                    'current_balance_sport': !that.state.naCasino ? that.props.user.sportRaspolozivo + data.iznos : that.props.user.sportRaspolozivo - data.iznos,
                    'current_balance_casino': that.state.naCasino ? that.props.user.casinoRaspolozivo + data.iznos : that.props.user.casinoRaspolozivo - data.iznos
                });

                that.props.updateUserFn(data.igrac);

                that.props.fetchDataFn && that.props.fetchDataFn();
                newState.successMsg = "Prenijeli ste " + casino.utils.numberWithCurrencyFromated(data.iznos, that.props.user.valuta) + " na račun " + (data.naCasino ? "Casino." : "Glavni.");
                if (that.state.pokerReloadBonus)
                    newState.successMsg += " I aktivirali 'Poker reload bonus'.";

                newState.iznos = "0,00";
                newState.naCasino = null;


                that.hideOkAction = setTimeout(() => {
                    that.setState({
                        close: true
                    });
                }, 2500);



            } else {
                newState.errorMsg = data.prijenosError || "Dogodila se pogreška, pokušajte ponovno.";
            }
            that.setState(newState);


        });
    }

    submitForm(e) {
        e.preventDefault();
        this.setState({ moneyTransferInProgress: true });
        if (this.state.currentStep == 2)
            if (this.validate())
                setTimeout(() => {
                    this.kreirajPrijenos();
                }, 350);



    }

    overlyClick() {
        if (this.state.currentStep != 3)
            this.setState({
                close: true
            });

        clearTimeout(this.hideOkAction);
    }

    bonusChboxClick(activeCasinoPromotionId) {
        let eventID = !this.state.casinoReloadBonus ? 58 : 59;
        casino.repos.eventRepo.create(eventID);

        this.setState({ casinoReloadBonus: !this.state.casinoReloadBonus, casinoReloadBonusId: activeCasinoPromotionId });
    }
    bonusPokerChboxClick() {
        let eventID = !this.state.pokerReloadBonus ? 58 : 59;
        casino.repos.eventRepo.create(eventID);

        this.setState({ pokerReloadBonus: !this.state.pokerReloadBonus });
    }

    getActiveCurrency() {
        return casino.config.guiValuta == "HRK" ? 'kn' : '€';
    }

    render() {
        let modalClass = 'modal modal-wallet';
        if (!this.state.close && this.state.currentStep > 1)
            modalClass += ' active';

        var max = this.state.naCasino ? this.props.user.sportRaspolozivo : this.props.user.casinoRaspolozivoZaIsplatu;
        let activeCasinoPromotion = this.props.user.promocije && this.props.user.promocije.availableItems.filter(x => !x.poker).length > 0 && this.props.user.promocije.availableItems[0];
        let activePokerPromotion = this.props.promotions && this.props.promotions.availableItems && this.props.promotions.availableItems.length > 0 && this.props.promotions.availableItems[0];


        // var iznosPrekidPrewager = 0;
        var prewagerActive = this.props.user && this.props.user.casinoPrewagerActive;
        // this.props.user && this.props.user.promocije.runningItems.length && this.props.user.promocije.runningItems.map(x => {
        //     if (x.jePrewager && x.active) {
        //         iznosPrekidPrewager = x.prekidIznos;
        //         prewagerActive = true;
        //     }
        // })


        return <div>
            <button disabled={this.props.user.sportRaspolozivo == null} className="btn-prenesi poker" onClick={() => this.showModal(true)}><div />Prebaci novac na CASINO & POKER</button>
            <button disabled={this.props.user.sportRaspolozivo == null} className="btn-prenesi glavni" onClick={() => this.showModal(false)}><div />Prebaci novac na SPORT</button>
            {
                ReactDOM.createPortal(
                    <div>
                        <div className={"modal-overlay" + (this.state.currentStep > 1 && !this.state.close ? ' active' : '')} onClick={this.overlyClick} ref={this.modalOverlay} />
                        <div className={modalClass} ref={this.modal} >

                            <div className={"modal-inner-overlay"} style={{ height: '100%' }} onClick={this.overlyClick} ref={this.modalInnerOverlay} />

                            <div className={"modal-content" + (this.state.currentStep >= 3 ? ' smanji-kutiju ' : '')} ref={this.modalContent}>
                                <form onSubmit={this.submitForm} >

                                    <div className={this.state.currentStep < 3 ? "modal--header" : 'hidden'}>
                                        {/* <span >Prebacivanje novca</span> */}
                                        <a className="link link-1 active" aria-current="true" onClick={this.closeModal} ><span className="close-icon icon ico-close-thin"></span></a>
                                    </div>
                                    <div className="modal--body">
                                        <div className={this.state.currentStep <= 3 ? 'image' : ' image hidden'}>
                                            <img src='content/images/assets/wallet1.png' />
                                            <img className={this.state.currentStep < 3 ? '' : 'hidden'} src='content/images/assets/arrows1.png' />
                                            <div className={this.state.currentStep < 3 ? 'hidden' : ''}>
                                                <img className='arrow2' src='content/images/assets/arrows2.png' />
                                            </div>
                                            <img src='content/images/assets/wallet2.png' />
                                        </div>

                                        <div className={this.state.currentStep > 3 ? 'image-done' : 'image-done hidden'}>
                                            {this.state.errorMsg && <img src='content/images/assets/icon-status-error.png' />}
                                            {!this.state.errorMsg && <img src='content/images/assets/icon-status-success.png' />}
                                        </div>

                                        <div className={this.state.currentStep < 3 ? 'normal' : 'hidden-animation'}>

                                            {this.state.naCasino && <div className="text-1">Stanje na <b>glavnom računu</b> je:</div>}
                                            {this.props.user && this.state.naCasino && <div className="text-2">
                                                {casino.utils.numberWithCurrencyFromated(this.props.user.sportRaspolozivo, this.props.user.valuta)}
                                            </div>}
                                            {!this.state.naCasino && <div className="text-1">Stanje na <b>casino & poker računu</b> je:</div>}
                                            {this.props.user && !this.state.naCasino && <div className="text-22">
                                                {casino.utils.numberWithCurrencyFromated(this.props.user.casinoRaspolozivoZaIsplatu, this.props.user.valuta)}
                                            </div>}
                                            <div className="money-seperator">
                                                <div /> <div />
                                            </div>



                                            <div className="text-3">Upiši iznos koji prebacuješ:</div>
                                            <div style={{ padding: '0rem 1.5rem .0rem 1.5rem', position: 'relative' }}>
                                                <div className={"input-iznos margin-top-small relative clearfix" + (this.state.errorMsg ? ' has-error' : '')} onClick={() => this.txtIznos.current.focus()}  >

                                                    <div className={this.state.errorMsg ? 'popup-error active animate-zoom' : 'popup-error'}>
                                                        <span>{this.state.errorMsg}</span>
                                                        <div className="arrow-down" />
                                                    </div>
                                                    <input onFocus={() => { this.setState({ focus: true, iznos: '' }); casino.utils.selectText(this.txtIznos.current); this.windowResize(); }}
                                                        onBlur={() => { this.setState({ focus: false }); this.validate(); }}
                                                        size={this.state.iznos && this.state.iznos.length > 0 ? (this.state.iznos.length) : 1}
                                                        ref={this.txtIznos} className="input-iznos--input" type="text" value={this.state.iznos}
                                                        onChange={this.iznosChanged} />
                                                    <span className="input-iznos--suffix">{casino.utils.currencySymbolFromValutaID(this.props.user.valutaID)}</span>
                                                </div>

                                                <button type="button" className='changeIznos plus' onClick={this.clickChangeIznosPlus}></button>
                                                <button type="button" className='changeIznos minus' onClick={this.clickChangeIznosMinus}></button>
                                            </div>

                                            <div className="brzi-iznos small-mobile-hidden">
                                                <button type="button" onClick={() => this.setIznos(0.25)} >25 % </button>
                                                <button type="button" onClick={() => this.setIznos(.5)} >50 % </button>
                                                <button type="button" onClick={() => this.setIznos(0.75)} >75 % </button>
                                                <button type="button" onClick={() => this.setIznos(1)} >100 %</button>
                                            </div>



                                            {this.state.naCasino && activeCasinoPromotion && <div className="clearfix as-table" style={{ padding: '1.5rem 1.5rem .5rem' }}>
                                                <div className={'checkbox as-table-cell-center ' + (this.state.casinoReloadBonus ? ' active' : '')}
                                                    onClick={() => this.bonusChboxClick(activeCasinoPromotion.id)}>

                                                    <div></div>

                                                </div>
                                                <span className="  as-table-cell-center ">&nbsp;&nbsp;</span>
                                                <span className="as-table-cell-center text-left text-1" >Želim <b> "{activeCasinoPromotion.naziv}" </b>
                                                    <br></br>
                                                    <span className="text-1" style={{ fontSize: '12px' }}>{'min. uplata ' +(activeCasinoPromotion.minDeposit) + ' ' + (activeCasinoPromotion.valuta == 1 ? 'kn' : '€') + ', maks. bonus  ' + (activeCasinoPromotion.maxBonus) + ' ' + (activeCasinoPromotion.valuta == 1 ? 'kn' : '€')}</span></span>
                                            </div>
                                            }

                                            {this.state.naCasino && this.props.activePokerReloadPromotion && <div className="clearfix as-table" style={{ padding: '1.5rem 1.5rem .5rem' }}>
                                                <div className={'checkbox as-table-cell-center ' + (this.state.pokerReloadBonus ? ' active' : '')}
                                                    onClick={() => this.bonusPokerChboxClick()}>
                                                    <div></div>
                                                </div>
                                                <span className="  as-table-cell-center ">&nbsp;&nbsp;</span>


                                                <span className="as-table-cell-center text-left text-1" >Želim <b>"<NavLink to={{
                                                    pathname: '/poker/bonuses/poker-reload/info',
                                                    state: { showNaCasino: true }
                                                }} style={{ textDecoration: 'underline' }} className='text-1'>Poker Reload Bonus</NavLink >" </b>
                                                    <br></br>
                                                    <span className="text-1" style={{ fontSize: '12px' }}>{'min. uplata ' + activePokerPromotion.minDeposit + ' ' + (activeCasinoPromotion.valuta == 1 ? 'kn' : '€') + ', maks. bonus  ' + activePokerPromotion.maxBonus + ' ' + (activeCasinoPromotion.valuta == 1 ? 'kn' : '€')}</span></span>




                                            </div>
                                            }



                                            {prewagerActive && this.state.naCasino && this.props.user.iznosGasiBonus && <div style={{ padding: '1.5rem 1.5rem .5rem', fontSize: '13px', textAlign: "center", fontWeight: '600' }}>
                                                Prilikom prijenosa aktivni bonus će se prekinuti, a sredstva u iznosu od <b>{casino.utils.numberToEuro2(this.props.user.raspolozivoPrewagerBonusVezaniIznosEuro)} ({casino.utils.numberToKune(this.props.user.raspolozivoPrewagerBonusVezaniIznos)}) </b>  će se poništiti!
                                            </div>}

                                            {prewagerActive && this.state.naCasino && !this.props.user.iznosGasiBonus && <div style={{ padding: '1.5rem 1.5rem .5rem', fontSize: '13px', textAlign: "center", fontWeight: '600' }}>
                                                Imate aktivan bonus! Uplaćena sredstva će vam biti vezana za bonus u visini iznosa bonusa te će svi dobitci iz igre biti vezani uz bonus. Bonus možete prekinuti
                                                <NavLink className='link blue' to={this.props.getHomePathFn(this.props.route.location, '/account/bonuses')} >
                                                    {' '}ovdje.
                                                </NavLink>
                                            </div>}


                                            {this.state.naCasino && <div style={{ padding: '1.5rem 1.5rem .0rem 1.5rem' }}>
                                                <button className="btn-prenesi poker" disabled={!this.state.iznos || this.state.errorMsg || this.state.moneyTransferInProgress}><div />Prenesi novac na CASINO & POKER</button>
                                            </div>}

                                            {!this.state.naCasino && <div style={{ padding: '1.5rem 1.5rem .0rem 1.5rem' }}>
                                                <button className="btn-prenesi glavni" disabled={!this.state.iznos || this.state.errorMsg || this.state.moneyTransferInProgress}><div />Prenesi novac na SPORT</button>
                                            </div>}




                                            <div className="text-center" style={{ padding: '0rem 1.5rem 1rem 1.5rem' }}>
                                                <a className="link link-4 " onClick={this.closeModal} > Odustani</a>
                                            </div>
                                        </div>
                                        <div className={this.state.currentStep == 3 ? 'text-info' : 'hidden'}>
                                            Prebacivanje u tijeku...
                                        </div>


                                        <div className={this.state.currentStep == 4 && !this.state.errorMsg ? 'text-success' : 'hidden'}>
                                            {this.state.successMsg}
                                        </div>
                                        <div className={this.state.currentStep == 4 && this.state.errorMsg ? 'text-error' : 'hidden'}>
                                            Dogodila se greška.
                                        </div>
                                        <div className={this.state.currentStep == 4 && this.state.errorMsg ? 'text-error-small' : 'hidden'}>
                                            {this.state.errorMsg}
                                        </div>

                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>,
                    this.el)
            }




        </div>;


        let activePokerReloadPromotion = this.props.promotions && this.props.activePokerReloadPromotion;


        // return (
        //     <div>
        //         <div className="padding-sides-medium ">
        //             <form onSubmit={this.submitForm} >

        //                 <span className="as-block">Prenesi novac na račun:</span>

        //                 <div className="segment margin-top-small">
        //                     <button type="button" className={this.state.naCasino === false ? 'segment--btn selected' : 'segment--btn'} onClick={() => this.odabirNaCasino(false)}><span>Glavni</span></button>
        //                     <div className="segment--seperator"></div>
        //                     <button type="button" className={this.state.naCasino === true ? 'segment--btn selected' : 'segment--btn'} onClick={() => this.odabirNaCasino(true)}><span>Casino</span></button>
        //                 </div>

        //                 <div className="flex-space-between  margin-top-small">
        //                     <button type="button" className={this.getPresentClass(10)} onClick={() => this.odabirIznosa(10)}><span>10,00</span></button>
        //                     <button type="button" className={this.getPresentClass(50)} onClick={() => this.odabirIznosa(50)}><span>50,00</span></button>
        //                     <button type="button" className={this.getPresentClass(100)} onClick={() => this.odabirIznosa(100)}><span>100,00</span></button>
        //                     <button type="button" className={this.getPresentClass(200)} onClick={() => this.odabirIznosa(200)}><span>200,00</span></button>
        //                     <button type="button" className={this.getPresentClass(-1)} onClick={() => this.odabirIznosa(-1)}><span>SVE</span></button>
        //                 </div>

        //                 <div className="input-group margin-top-small clearfix">
        //                     <input ref="txtIznos" className="input-group--input" type="text" value={this.state.iznos} onChange={this.iznosChanged} onFocus={() => this.refs.txtIznos.select()} />
        //                     <span className="input-group--prefix">Ručni unos:</span>
        //                     <span className="input-group--suffix">kn</span>
        //                 </div>

        //                 <div className={this.state.errorMsg ? 'error-message margin-top' : 'hidden'}>
        //                     <span className="icon ico-alert"></span>
        //                     <span>{this.state.errorMsg}</span>
        //                 </div>

        //                 {activePokerReloadPromotion && <div className="clearfix margin-top-small as-table">
        //                     <div className={'checkbox as-table-cell-center' + (this.state.pokerReloadBonus ? ' active' : '') + (this.state.naCasino ? '' : ' disabled')}
        //                         onClick={() => this.setState({ pokerReloadBonus: !this.state.pokerReloadBonus && this.state.naCasino, currentStep: 1, errorMsg: null, successMsg: null })}>

        //                         <div></div>

        //                     </div>
        //                     <span className="  as-table-cell-center ">&nbsp;</span>
        //                     <span className="as-table-cell-center text-left" >   Želim "Poker reload bonus" <span className="text text-2">(min 100kn)</span></span>
        //                 </div>
        //                 }

        //                 <div className="margin-top">
        //                     <div className={this.state.currentStep == 1 ? '' : 'hidden'}>
        //                         <button type="submit" disabled={this.state.iznos == "" || this.state.naCasino == null} className="as-block btn fill large orange">Prenesi novac</button>
        //                     </div>
        //                     <div className={this.state.currentStep >= 2 && this.state.currentStep < 4 ? 'flex-space-between' : 'hidden'}>
        //                         <button type="submit" disabled={this.state.currentStep != 2} className="btn fill large green width-49-percent">Potvrdi</button>
        //                         <button type="button" disabled={this.state.currentStep != 2} className="btn fill large gray-blue width-49-percent" onClick={this.goToStep1}>Odustani</button>
        //                     </div>
        //                 </div>
        //                 <div className={this.state.successMsg ? 'success-message' : 'hidden'}>
        //                     <span className="icon ico-check-indeterminate"></span>
        //                     <span>{this.state.successMsg}</span>
        //                 </div>

        //                 <div className="margin-top margin-bottom"></div>
        //             </form>
        //             <br />
        //         </div>
        //         {activePokerReloadPromotion && <div>
        //             <hr />
        //             <div className="padding-sides-medium" style={{ backgroundColor: '#f2f4f6' }}>

        //                 <h2 className="v5">Aktivne promocije</h2>

        //                 <table style={{ width: '100%' }}>
        //                     <tbody>
        //                         <tr>
        //                             <td colSpan="3">
        //                                 <h3 className="v4">Poker reload bonus</h3>
        //                             </td>
        //                         </tr>
        //                         <tr>
        //                             <td style={{ width: '34%', verticalAlign: 'top' }}><img src='content/images/poker/bonusi/relaod-bonus.jpg' style={{ width: '100%', marginTop: '2px', borderRadius: '8%' }} /> </td>
        //                             <td style={{ width: '2%' }} ></td>
        //                             <td style={{ width: '64%', verticalAlign: 'top' }}>

        //                                 <div className="margin-bottom ">
        //                                     Trenutno je aktualna promocija “Poker reload bonus” koja omogućuje da udvostručite Vaš ulog. Minimalni ulog je 100,00 kuna a maksimalni 2.000,00 kuna. Promocija traje do 06.03.2018. u 12:00 sati.</div>


        //                                 <ReactRouterDOM.NavLink className="btn fill medium blue as-inline-block" to={'/poker/bonuses/poker-reload'}>Saznaj više</ReactRouterDOM.NavLink>

        //                             </td>
        //                         </tr>
        //                     </tbody>
        //                 </table>

        //                 <br />
        //                 <br />
        //             </div>
        //         </div>
        //         }



        //     </div >

        // );
    }
};
